import { useContext } from "react";
import UserDataContext from "../contexts/UserDataManagment";

const UseUserDataSettings = () => useContext(UserDataContext);

export default UseUserDataSettings;
